/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getDiscountList = (payload, callback) =>
  req.list(
    c.GET_DISCOUNT,
    'api/v1/rpt/administrator/settings/discounts',
    payload,
    callback
  );

export const getSingleDiscount = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_DISCOUNT,
    `api/v1/rpt/administrator/settings/discounts/${id}`,
    payload,
    callback
  );

export const createDiscount = (payload, callback) =>
  req.create(
    c.CREATE_DISCOUNT,
    'api/v1/rpt/administrator/settings/discounts',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateDiscount = (id, payload, callback) =>
  req.update(
    c.UPDATE_DISCOUNT,
    `api/v1/rpt/administrator/settings/discounts/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeDiscount = (id, payload, callback) =>
  req.remove(
    c.REMOVE_DISCOUNT,
    `api/v1/rpt/administrator/settings/discounts/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getLandClassificationsList = (payload, callback) =>
  req.list(
    c.GET_LAND_CLASSIFICATIONS,
    'api/v1/rpt/administrator/land/settings/land_classifications?isPaginate=1',
    payload,
    callback
  );